<template>
  <div
    class="bg-grey-900 bg-700 w-56 h-24 border-grey-700 border alignment rounded-lg overflow-hidden"
  >
    <div class="flex flex-col justify-between">
      <div class="flex flex-row justify-between">
        <align-top-left
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'left-top',
            'text-pink': selectedValue === 'left-top'
          }"
          @click="select('left-top');"
        />
        <align-top
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'top',
            'text-pink': selectedValue === 'top'
          }"
          @click="select('top');"
        />
        <align-top-right
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'right-top',
            'text-pink': selectedValue === 'right-top'
          }"
          @click="select('right-top');"
        />
      </div>
      <div class="flex flex-row justify-between">
        <align-left
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'left',
            'text-pink': selectedValue === 'left'
          }"
          @click="select('left');"
        />
        <align-center
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'center',
            'text-pink': selectedValue === 'center'
          }"
          @click="select('center');"
        />
        <align-right
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'right',
            'text-pink': selectedValue === 'right'
          }"
          @click="select('right');"
        />
      </div>
      <div class="flex flex-row justify-between">
        <align-bottom-left
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'left-bottom',
            'text-pink': selectedValue === 'left-bottom'
          }"
          @click="select('left-bottom');"
        />
        <align-bottom
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'bottom',
            'text-pink': selectedValue === 'bottom'
          }"
          @click="select('bottom');"
        />
        <align-bottom-right
          class="m-2 cursor-pointer fill-current"
          :class="{
            'text-grey-500': selectedValue !== 'right-bottom',
            'text-pink': selectedValue === 'right-bottom'
          }"
          @click="select('right-bottom');"
        />
      </div>
    </div>
  </div>
</template>
<script>
import AlignCenter from '../assets/align-center.svg';
import AlignLeft from '../assets/align-left.svg';
import AlignRight from '../assets/align-right.svg';
import AlignTop from '../assets/align-top.svg';
import AlignBottom from '../assets/align-bottom.svg';
import AlignTopLeft from '../assets/align-top-left.svg';
import AlignBottomLeft from '../assets/align-bottom-left.svg';
import AlignTopRight from '../assets/align-top-right.svg';
import AlignBottomRight from '../assets/align-bottom-right.svg';

export default {
  name: 'AlignmentPanel',
  components: {
    AlignLeft,
    AlignRight,
    AlignTop,
    AlignBottom,
    AlignTopLeft,
    AlignBottomLeft,
    AlignTopRight,
    AlignBottomRight,
    AlignCenter
  },
  props: ['value', 'alignments'],
  computed: {
    selectedValue() {
      for (const alignment in this.alignments) {
        if (this.alignments[alignment] === this.value) return alignment;
      }
      return null;
    }
  },
  methods: {
    select(value) {
      this.$emit('input', this.alignments[value]);
      this.$emit('change', this.alignments[value]);
    }
  }
};
</script>
<style lang="css" scoped>
.alignment {
  width: 14.3rem !important;
}
</style>
